import { render } from "./TemplateShow.vue?vue&type=template&id=ad367b40"
import script from "./TemplateShow.vue?vue&type=script&lang=js"
export * from "./TemplateShow.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/somethingred.j20.nl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__